import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { ExtendedSelectorsBody } from '@components-shared/forms/ExtendedSelectors/ExtendedSelectorsBody';
import { IGroupOption, IGroupSelectorProps } from '@components-shared/forms/ExtendedSelectors/types';

export const GroupSelector = (props: IGroupSelectorProps): JSX.Element => {
  const { name, value, groupItemList, selectedGroupItemList, groupByDefault, groupAttributes, onChange } = props;
  const [selectedGroup, setSelectedGroup] = useState<string>('');
  const [selectedGroupOption, setSelectedGroupOption] = useState<IGroupOption[]>([]);

  const setPreviousSelectedGroup = useCallback(() => {
    if (!value || !groupItemList) {
      return;
    }
    const selectedGroupItem = selectedGroupItemList.find((option) => option.value === Number(value));

    const group =
      groupItemList &&
      selectedGroupItem &&
      groupItemList.find((option) => option.value === selectedGroupItem?.filterBy);

    setSelectedGroup(String(group?.value));
  }, [selectedGroupItemList, groupItemList, value]);

  const setPreferredOptionByDefault = useCallback(
    () => {
      const preferredOption = selectedGroupItemList.find((option) => option.preferred);

      if (!preferredOption) {
        return;
      } else if (!value && String(preferredOption.value) !== value) {
        setSelectedGroup(String(preferredOption.filterBy));

        onChange(name, String(preferredOption.value));

        return;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedGroupItemList],
  );

  useEffect(() => {
    setPreferredOptionByDefault();
  }, [setPreferredOptionByDefault]);

  useEffect(() => {
    setPreviousSelectedGroup();
    if (groupByDefault) {
      setSelectedGroup(String(groupByDefault));
    }
  }, [setPreviousSelectedGroup, groupByDefault]);

  useEffect(() => {
    if (groupAttributes?.disabled && groupItemList) {
      const firstGroupOptionByDefault = groupItemList[0].value;

      setSelectedGroup(String(firstGroupOptionByDefault));
    }
  }, [groupAttributes?.disabled, groupItemList]);

  useEffect(() => {
    const options = selectedGroupItemList.filter((option) =>
      option.filterBy === undefined ? true : option.filterBy === Number(selectedGroup),
    );

    setSelectedGroupOption(options);
  }, [selectedGroupItemList, selectedGroup]);

  const onChangeGroup = (e: ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;

    if (!value || value !== selectedGroup) {
      onChange(name, '');
    }

    setSelectedGroup(e.target.value);
  };

  const onChangeGroupItem = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(name, e.target.value);
  };

  return (
    <ExtendedSelectorsBody
      {...props}
      groupSelectedValue={selectedGroup}
      selectedGroupItemList={selectedGroupOption}
      onGroupChange={onChangeGroup}
      onSelectedGroupOptionsChange={onChangeGroupItem}
    />
  );
};
